
import { useEffect, useRef, useState } from 'react';

const stats = [
  { icon: 'ri-home-4-fill', value: '1.200+', label: 'Imóveis Negociados em Brasília', color: 'from-teal-400 to-emerald-400' },
  { icon: 'ri-time-fill', value: '28 dias', label: 'Tempo Médio para Vender', color: 'from-orange-400 to-amber-400' },
  { icon: 'ri-group-fill', value: '5.000+', label: 'Clientes Satisfeitos', color: 'from-emerald-400 to-cyan-400' },
  { icon: 'ri-percent-fill', value: '98%', label: 'Taxa de Satisfação', color: 'from-rose-400 to-pink-400' },
  { icon: 'ri-calendar-check-fill', value: '9+', label: 'Anos no Mercado de Brasília', color: 'from-violet-400 to-purple-400' },
  { icon: 'ri-money-dollar-circle-fill', value: 'R$ 500M+', label: 'Volume Total Negociado', color: 'from-yellow-400 to-orange-400' },
];

const StatsProprietarios = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 bg-gradient-to-br from-gray-900 via-teal-900 to-gray-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-teal-500 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-500 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-teal-500/20 border border-teal-400/30 rounded-full text-teal-300 font-semibold text-sm tracking-wider uppercase mb-4">
            Resultados Reais
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Números Que Falam Por Si
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Quase uma década construindo confiança e entregando resultados no mercado imobiliário de Brasília
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {stats.map((stat, i) => (
            <div
              key={i}
              className={`bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20 hover:bg-white/15 transition-all hover:scale-105 text-center ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${i * 80}ms`, transition: 'all 0.6s ease' }}
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${stat.color} rounded-xl flex items-center justify-center mb-5 mx-auto`}>
                <i className={`${stat.icon} text-3xl text-white`}></i>
              </div>
              <div className="text-4xl font-bold mb-2">{stat.value}</div>
              <div className="text-gray-300 text-sm leading-snug">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-xl text-gray-300 italic max-w-3xl mx-auto mb-8">
            "Atuo no mercado imobiliário de Brasília desde 2017. Meu compromisso é entregar o melhor resultado para cada proprietário que confia em mim."
          </p>
          <div className="flex items-center justify-center gap-4">
            <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-teal-400">
              <img
                src="https://static.readdy.ai/image/b38d0475ce589291eceb67661996448f/2a2558c7aa812b59f3632681c7e8edfc.png"
                alt="Daniel Carvalho"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="text-left">
              <div className="font-bold text-lg">Daniel Carvalho</div>
              <div className="text-gray-400 text-sm">Especialista Imobiliário · Brasília, DF</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsProprietarios;
